import { Box, Typography } from "@mui/material";
import { ScrapEyesEvent } from "components/scrapEyeLabelling/types";
import { useTenantTranslation } from "hooks/formatters";
import { AreaChip } from "../../components/AreaChip";
import { useHotkeyContext } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { useAreaLabel } from "components/scrapEyeLabelling/hooks/useAreaLabel";
import { KeyIndicator } from "../../components/KeyIndicator";

interface LocationSectionProps {
  event: ScrapEyesEvent;
  availableAreas: string[];
  location: string;
  onChange: (updates: Partial<ScrapEyesEvent>) => void;
  onOpenAreaModal?: () => void;
}

export const LocationSection = ({
  event,
  availableAreas,
  location,
  onChange,
  onOpenAreaModal,
}: LocationSectionProps) => {
  const { t } = useTenantTranslation();
  const { getDisplayKey } = useHotkeyContext();
  const resolveAreaLabel = useAreaLabel(location);

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Typography variant="subtitle2">{t("location")}</Typography>
        {onOpenAreaModal ? (
          <KeyIndicator
            keyLabel={getDisplayKey("changeAreaMode")}
            variant="light"
          />
        ) : null}
      </Box>
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        {onOpenAreaModal ? (
          <AreaChip
            selected={false}
            area={event.area ?? ""}
            label={
              event.area == null
                ? t("selectArea")
                : resolveAreaLabel(event.area)
            }
            onClick={onOpenAreaModal}
          />
        ) : (
          availableAreas.map((area) => (
            <AreaChip
              key={area}
              area={area}
              label={resolveAreaLabel(area)}
              selected={event.area === area}
              onClick={() => {
                onChange({ area: area });
              }}
            />
          ))
        )}
      </Box>
    </Box>
  );
};
